<div class="position-relative" id="{{'item-' + badMoodStreak.id}}">

    <div class="streaks-card-wrapper card" id="{{badMoodStreak.id}}">
            <article class="streaks-card">
                <div class="streaks-card-content">
                    <a href="https://help.teammood.com/en/articles/6701896-about-bad-mood-streaks" target="_blank" class="streak-help-link"><i class="fa-solid fa-circle-question"></i></a>
                    <h4>{{ 'bad-mood-streak.title' | translate}}</h4>
                    <p class="streak-text mb-3">{{ 'bad-mood-streak.description' | translate}}</p>
                </div>
                <div class="media-bottom card-bottom streaks-card-actions">
                    <tm-reactions [timelineItem]="badMoodStreak" [reactionType]="'care'"
                               (onReacted)="onReacted($event)"
                               (onToggleThreads)="toggleThreads()"
                               (onDiscuss)="discuss()"></tm-reactions>

                    @if(showThreads){
                    <tm-threads [timelineItem]="badMoodStreak" #threadsComponent
                                [userInfos]="userInfos"
                                (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
                    }
                </div>
            </article>
        </div>
    <!-- @if(badMoodStreak.educationalCard){
    <div class="position-absolute mb-md-3 hide-for-mobile top-0 start-100 ms-4"
         [class]="{'hide-for-large-screen': !isOdd, 'hide-oft': isOdd }">
        <tm-educational-card
                [educCardId]="badMoodStreak.educationalCard"
                [threadComponent]="getThreadsComponent">
            </tm-educational-card>
    </div>
    } -->
    @if(badMoodStreak.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="badMoodStreak.managerPanel"
                              [reviewed]="badMoodStreak.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>

